import { Box, CircularProgress, Typography, styled } from '@mui/material';

export const SpinnerContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
});

export const StyledCircularProgress = styled(CircularProgress)({
  color: 'white',
  marginBottom: '24px',
});

export const LoadingText = styled(Typography)({
  color: 'white',
  fontWeight: 500,
});
